<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical" class="color999"></el-divider>
        <span class="color999 cur" @click="back">开单打卡&nbsp;/&nbsp;</span>
      </div>
      <div>打卡统计</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <el-date-picker v-model="query.reportMonth" type="month" :clearable="false" value-format="yyyy-MM"
              placeholder="选择月" @change="totalCounts"></el-date-picker>
          </div>
          <div class="plrb16" v-perm="{ key: 'attendancePunch', value: 'attendancePunch:reportList' }">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名" />
              <el-table-column prop="workDay" label="出勤(天)" width="auto" />
              <el-table-column prop="leaveTotal" width="auto" label="请假(天)" />
              <el-table-column prop="publicLeaveTotal" width="auto" label="公休(天)" />
              <el-table-column prop="restLeaveTotal" width="auto" label="休假(天)" />
              <el-table-column prop="yearLeaveTotal" width="auto" label="年假(天)" />
              <el-table-column prop="noAttendanceTotal" width="auto" label="旷工(天)" />
              <el-table-column prop="absenceTotal" width="auto" label="缺卡(次)" />
              <el-table-column prop="overtimeTotal" width="auto" label="迟到(次)" />
              <el-table-column prop="leaveEarlyTotal" width="auto" label="早退(次)" />
			  <el-table-column prop="serveDuration" width="auto" label="工时(小时)" />
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" v-perm="{ key: 'attendancePunch', value: 'attendancePunch:reportDetail' }"
                    @click="details(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <!-- <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      url: this.$url.attendance.list,
      urlCount: this.$url.attendance.count,
      query: {
        reportMonth: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: {},
  computed: {},

  created() {
    this.query.reportMonth = this.formatMonth(new Date())
    this.totalCounts();
  },

  methods: {
    details(row) {
      console.log(this.query.reportMonth);
      this.$router.push({
        path: "/dataList/attendanceDetail",
        query: {
          month: this.query.reportMonth,
          staffId: row.staffId
        }
      })
    },
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    totalCounts() {
      this.getData();
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

.page-head {
  height: 100%;
}

.mains-content {
  height: calc(100% - 72px);

  .member-content-box {
    background: #fff;
  }

  .member-header {
    padding: 16px;
    display: flex;
  }
}</style>